// extracted by mini-css-extract-plugin
export default {"labelText":"Oz9jgElOhVULfhauFxLk","progressBar":"T6EGrnT1xuLnjWnLCB6p","progressFill":"GtfcvIwPvoKqUOhyH2xc","completed":"q6pzOSAsJSn_sEHJX4da","error":"a75asBU8CpauAj4wWSoW"};